export default __webpack_public_path__ + "static/media/blue_title.5ac52c64.svg";